import { IDashboardHistoryInstance } from '@cxstudio/dashboards/dashboard-history.factory';
import Widget from '@cxstudio/dashboards/widgets/widget';

export class WidgetDashboardFilterApplication {
	constructor(
		public widgetSettings: Widget,
		public filtersProvider: IDashboardHistoryInstance,
	) {}
}
